export function setRgTrx(state, trxs) {
    state.rgTrx = trxs;
}

export function setInvestorTrx(state, trxs) {
    state.investorTrx = trxs;
}

export function setSupplierTrx(state, trxs) {
    state.supplierTrx = trxs;
}

export function setApplicantTrx(state, trxs) {
    state.applicantTrx = trxs;
}

export function setOpenPayInAccount(state, value) {
    state.processors.openpay.inAccount = value;
}

export function setStpInAccount(state, value) {
    state.processors.stp.inAccount = value;
}

export function changePaymentProcessor(state, { trxIndex, processor, trx }) {
    let transaction = state[trxIndex].filter((t) => t.id === trx.id );
    transaction[0].processor = processor;

   setTotalAmounts(state);
}

export function deleteItem(state, { trxIndex, id }) {
    let transaction = state[trxIndex].filter((t) => t.id === id );
    transaction[0].hidden = true;

    setTotalAmounts(state);
}

export function setQueueStatus(state, { trxIndex, trx, status, message }) {
    let transaction = state[trxIndex].filter((t) => t.id === trx.id );
    transaction[0].queue = {
        status: status,
        message: message
    };
}

export function setTotalAmounts(state, resetValues) {
    state.processors.openpay.required = 0;
    state.processors.stp.required = 0;

    state.rgTrx.forEach((trx) => {
        if(trx.status === 0 && trx.processor === 'openpay' && trx.hidden === false) {
            state.processors.openpay.required += trx.amount;
        }
        if(trx.status === 0 && trx.processor === 'stp' && trx.hidden === false) {
            state.processors.stp.required += trx.amount;
        }
    });

    state.investorTrx.forEach((trx) => {
        if(trx.status === 1 && trx.processor === 'openpay' && trx.hidden === false) {
            state.processors.openpay.required += trx.amount;
        }
        if(trx.status === 1 && trx.processor === 'stp' && trx.hidden === false) {
            state.processors.stp.required += trx.amount;
        }
    });

    state.applicantTrx.forEach((trx) => {
        if(trx.status === 1 && trx.processor === 'openpay' && trx.hidden === false) {
            state.processors.openpay.required += trx.amount;
        }
        if(trx.status === 1 && trx.processor === 'stp' && trx.hidden === false) {
            state.processors.stp.required += trx.amount;
        }
    });

    state.supplierTrx.forEach((trx) => {
        if(trx.status === 0 && trx.processor === 'openpay' && trx.hidden === false) {
            state.processors.openpay.required += trx.amount;
        }
        if(trx.status === 0 && trx.processor === 'stp' && trx.hidden === false) {
            state.processors.stp.required += trx.amount;
        }
    });
}
